/**
 * External Links
 * Automatically adds target="_blank" and rel="noopener noreferrer"
 * to any anchor that points to a different hostname.
 */

const init = () => {
  document.querySelectorAll('a[href^="http"]').forEach((link) => {
    if (link.hostname && link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
};

export { init };
